import React from "react";
import { Inbox } from "lucide-react";

/**
 * Empty state for lists/tables/panels. Consistent illustration slot + title +
 * description + CTA.
 */
export default function EmptyStateDS({
  icon = <Inbox size={20} strokeWidth={1.6} />,
  title = "Nothing here yet",
  description,
  cta,
  testId,
}) {
  return (
    <div className="hbf-empty" data-testid={testId || "empty-state"}>
      <div className="hbf-empty__icon">{icon}</div>
      <div className="hbf-empty__title">{title}</div>
      {description && <div className="hbf-empty__desc hbf-muted">{description}</div>}
      {cta && <div className="hbf-empty__cta">{cta}</div>}
    </div>
  );
}
